function ChannelCardListBtn() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-label="채널 카드 리스트"
    >
      <desc>채널 카드 리스트</desc>
      <defs>
        <clipPath id="n9eixaqiza">
          <path
            fill="#fff"
            stroke="#707070"
            d="M0 0h24v24H0z"
            data-name="사각형 11461"
            opacity="0.33"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#n9eixaqiza)" data-name="마스크 그룹 4464">
        <g
          fill="none"
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.8"
          data-name="그룹 13615"
          transform="translate(5.352 6)"
        >
          <ellipse
            cx="3.018"
            cy="3.141"
            data-name="타원 32"
            rx="3.018"
            ry="3.141"
            transform="translate(3.631)"
          ></ellipse>
          <path
            d="M12.149 12.001a5.5 5.5 0 10-11 0"
            data-name="패스 352"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default ChannelCardListBtn
